interface IconFlameFilledProps {
  size?: number | string;
  color?: string;
  className?: string;
}
/**
 *
 * IconFlameFilled
 */
const IconFlameFilled = ({ size = 48, color = '#4ADDC2', className }: IconFlameFilledProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 49 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_93_9694)">
      <path
        d="M20.5 3.99999C20.5 2.23999 22.612 1.33799 23.884 2.55599C27.8 6.30799 30.076 14.546 27.384 20.796L27.224 21.144L27.248 21.15C28.498 21.416 29.654 20.29 31.854 16.804L32.134 16.356C32.2963 16.0948 32.5166 15.8745 32.7779 15.7123C33.0391 15.5501 33.3342 15.4503 33.6403 15.4207C33.9464 15.3911 34.2552 15.4324 34.5427 15.5416C34.8302 15.6507 35.0887 15.8247 35.298 16.05C37.966 18.92 40.5 24.804 40.5 28.59C40.5 37.12 33.318 44 24.5 44C15.682 44 8.5 37.12 8.5 28.588C8.5 24.084 10.544 19.156 13.764 15.986L14.974 14.808C15.456 14.336 15.842 13.948 16.21 13.56C19.07 10.536 20.5 7.71199 20.5 3.99999Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_93_9694">
        <rect width="48" height="48" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export default IconFlameFilled;
